var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28698 9.04166C7.21039 9.04202 7.13449 9.02708 7.06375 8.99772C6.99301 8.96835 6.92884 8.92515 6.87502 8.87065L4.1778 6.15012C4.10676 6.04056 4.07457 5.91031 4.08637 5.78027C4.09818 5.65022 4.1533 5.52791 4.24291 5.43293C4.33251 5.33794 4.45141 5.27579 4.58055 5.25644C4.70969 5.23709 4.84158 5.26165 4.9551 5.32619L7.28698 7.65807L9.61887 5.32619C9.73239 5.26165 9.86428 5.23709 9.99342 5.25644C10.1226 5.27579 10.2415 5.33794 10.3311 5.43293C10.4207 5.52791 10.4758 5.65022 10.4876 5.78027C10.4994 5.91031 10.4672 6.04056 10.3962 6.15012L7.67563 8.87065C7.57263 8.97514 7.4336 9.03631 7.28698 9.04166V9.04166Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGrey);
export default __webpack_public_path__ + "static/media/chevron-down-grey.eb46f91ea6e2cde2b3f3ccd29954e598.svg";
export { ForwardRef as ReactComponent };